<!-- 列表页公共导航栏 -->
<template>
    <div class="ml_15">
        <div class="exportBtn" @click="dialogVisible = true">
            <i class="iconfont icon-iconfont_down mr_5"></i>下载
        </div>
        <el-dialog custom-class="export-dialog" title="导出设置" :visible.sync="dialogVisible">
            <div class="dialogMain">
                <div class="main-item">
                    <div class="label">选择要导出的模块</div>
                    <div class="content">
                        <el-checkbox-group class="zfyx-checkbox-group" v-model="checkList">
                            <el-checkbox
                                :label="item.value"
                                v-for="(item,index) in list"
                                :key="index"
                            >{{item.label}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
            <div class="dialogFooter">
                <div class="submitBtn" @click="exportData">下载</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import permission from '@/mixins/permission.js'
export default {
    mixins: [permission],
    props: {
        module: {
            type: String,
            default: 'land'
        }
    },
    data() {
        return {
            dialogVisible: false,
            checkList: [1],
            exportList: {
                // 房企拿地监控
                land: [
                    { label: '土地概况', value: 1 },
                    { label: '上市信息', value: 2 },
                    { label: '成交信息', value: 3 }
                ],
                // 房企项目开工监控
                project: [
                    { label: '项目概况', value: 1 },
                    { label: '产品总览', value: 2 },
                    { label: '企业概况', value: 3 }
                ],
                // 全装修市场监控
                market: [
                    { label: '项目概况', value: 1 },
                    { label: '产品总览', value: 2 },
                    { label: '企业概况', value: 3 }
                ]
            }
        }
    },
    computed: {
        list() {
            return this.exportList[this.module]
        }
    },
    methods: {
        exportData() {
            this.dialogVisible = false
            this.$emit('exportData', this.checkList.join(','))
        }
    }
}
</script>

<style lang="scss">
.export-dialog {
    .el-dialog__header {
        padding: 0.2rem 0.2rem 0.1rem;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.13);
        position: relative;
        z-index: 10;
        .el-dialog__title {
            font-size: 0.2rem;
        }
        .el-dialog__headerbtn {
            font-size: 0.2rem;
        }
    }
    .el-dialog__body {
        font-size: 0.14rem;
        padding: 0;
    }
    .dialogMain {
        padding: 0.3rem 0.2rem;
        .main-item {
            display: flex;
            align-items: center;
            .label {
                font-size: 0.14rem;
                font-weight: bold;
            }
            .content {
                padding-left: 0.2rem;
            }
        }
    }

    .dialogFooter {
        height: 0.52rem;
        border-top: 1px solid #eeeeee;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        padding: 0 0.36rem;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.13);
        .submitBtn {
            width: 0.98rem;
            height: 0.32rem;
            line-height: 0.32rem;
            color: white;
            text-align: center;
            cursor: pointer;
            font-size: 0.14rem;
            border-radius: 0.16rem;
            background: linear-gradient(180deg, #00a3dd 0%, #0086b7 100%);
        }
    }
}
</style>
